// Need to use the React-specific entry point to import createApi
import type {
  GetInstanceListRequest,
  GetInstanceListV2Request,
  GetListResponseOfInstanceResponse,
  InstanceCloneRequest,
  InstanceDeleteRequest,
  InstanceRequest,
  InstanceResponse,
} from 'src/api/ProactApiClient';
import {instanceApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

// Define a service using a base URL and expected endpoints
export const instanceApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getInstanceList: builder.query<
      GetListResponseOfInstanceResponse,
      GetInstanceListRequest
    >({
      queryFn: clientQuery(params => instanceApiClient.list(params)),
      providesTags: ['Instances'],
    }),
    getInstanceListV2: builder.query<
      GetListResponseOfInstanceResponse,
      GetInstanceListV2Request
    >({
      queryFn: clientQuery(params => instanceApiClient.listV2(params)),
      providesTags: ['Instances'],
    }),
    getInstance: builder.query<InstanceResponse, number>({
      queryFn: clientQuery(id => instanceApiClient.get(id)),
      providesTags: ['Instances'],
    }),
    createInstance: builder.mutation<InstanceResponse, InstanceRequest>({
      queryFn: clientQuery(request => instanceApiClient.create(request)),
      invalidatesTags: ['Instances'],
    }),
    updateInstance: builder.mutation<InstanceResponse, InstanceRequest>({
      queryFn: clientQuery(request => instanceApiClient.update(request)),
      invalidatesTags: ['Instances'],
    }),
    cloneInstance: builder.mutation<string | null, InstanceCloneRequest>({
      queryFn: clientQuery(request => instanceApiClient.clone(request)),
      invalidatesTags: ['Instances'],
    }),
    deleteInstance: builder.mutation<void, InstanceDeleteRequest>({
      queryFn: voidClientQuery(request => instanceApiClient.delete(request)),
      invalidatesTags: ['Instances'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetInstanceListQuery,
  useGetInstanceListV2Query,
  useGetInstanceQuery,
  useCreateInstanceMutation,
  useUpdateInstanceMutation,
  useCloneInstanceMutation,
  useDeleteInstanceMutation,
} = instanceApi;
